/**
 * The app's one icon set: 16px line icons drawn on a 16×16 grid with
 * stroke = currentColor, so they follow the text colour wherever they sit.
 * Decorative by default (aria-hidden); the control around an icon names it.
 */

const PATHS = {
  // Navigation (src/layouts/navigation.js names these).
  grid: "M3 3h4v4H3zM9 3h4v4H9zM3 9h4v4H3zM9 9h4v4H9z",
  launch: "M8 11V3M5 6l3-3 3 3M3 13h10",
  book: "M2.5 3.5h4a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 0-1.5-1.5h-4zM13.5 3.5h-4A1.5 1.5 0 0 0 8 5v8a1.5 1.5 0 0 1 1.5-1.5h4z",
  users: "M6 7.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zM2 13c0-2.2 1.8-3.5 4-3.5s4 1.3 4 3.5M10.5 3.2a2.25 2.25 0 0 1 0 4.1M11.5 9.6c1.5.4 2.5 1.6 2.5 3.4",
  send: "M14 2 7 9M14 2l-4.5 12L7 9 2 6.5z",
  clipboard: "M5.5 3H4v11h8V3h-1.5M6 2h4v2H6zM6 7.5h4M6 10h4",
  shield: "M8 2l5 2v4c0 3-2.2 5.2-5 6-2.8-.8-5-3-5-6V4zM6 8l1.5 1.5L10.5 6.5",
  reports: "M3 13V8M6.5 13V4M10 13V7M13.5 13V10M2 13.5h12",
  lock: "M4.5 7V5a3.5 3.5 0 0 1 7 0v2M3.5 7h9v6.5h-9z",
  // Existing reports (src/layouts/Sidebar.jsx names these per report).
  chart: "M2 2.5v11h12M4.5 10l3-3.5 2.5 2 3.5-4.5",
  globe: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zM2 8h12M8 2c1.7 1.8 2.5 3.8 2.5 6S9.7 12.2 8 14M8 2C6.3 3.8 5.5 5.8 5.5 8s.8 4.2 2.5 6",
  phone: "M5 1.5h6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1zM7 12.5h2",
  funnel: "M2 3h12L9.5 8.5V13l-3 1.5v-6z",
  play: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zM6.75 5.75v4.5L10.5 8z",
  monitor: "M2 3h12v8H2zM5.5 14h5M8 11v3",
  cap: "M8 3 1.5 6 8 9l6.5-3zM4 7.2V10c0 1 1.8 2 4 2s4-1 4-2V7.2M14.5 6v3.5",
  broadcast: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.2 10.8a4 4 0 0 1 0-5.6M10.8 5.2a4 4 0 0 1 0 5.6M3.1 12.9a7 7 0 0 1 0-9.8M12.9 3.1a7 7 0 0 1 0 9.8",
  activity: "M1.5 8h3l2-5 3 10 2-5h3",
  stethoscope: "M3.5 2v3.5a3 3 0 0 0 6 0V2M6.5 8.5V10a3 3 0 0 0 6 0V9.5M12.5 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  // Controls.
  menu: "M2.5 4h11M2.5 8h11M2.5 12h11",
  close: "M4 4l8 8M12 4l-8 8",
  chevronDown: "M4.5 6.5 8 10l3.5-3.5",
  chevronLeft: "M9.5 4 6 8l3.5 4",
  chevronRight: "M6.5 4 10 8l-3.5 4",
  arrowRight: "M3 8h10M9 4l4 4-4 4",
  arrowLeft: "M13 8H3M7 4 3 8l4 4",
  clock: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zM8 4.5V8l2.5 1.5",
  calendar: "M3 4.5h10v9H3zM3 7.5h10M5.5 2.5v3M10.5 2.5v3",
  filter: "M2 4h12M4.5 8h7M7 12h2",
  search: "M7 12A5 5 0 1 0 7 2a5 5 0 0 0 0 10zM14 14l-3.5-3.5",
  download: "M8 2.5v8M4.5 7 8 10.5 11.5 7M3 13.5h10",
  info: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zM8 7.25V11M8 5h.01",
  scope: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM8 8h.01",
  logout: "M6 2.5H3.5v11H6M10.5 5l3 3-3 3M13.5 8H6",
  mail: "M2.5 4h11v8h-11zM2.5 4.5 8 9l5.5-4.5",
  key: "M10 9.5a3.5 3.5 0 1 0-3.4-2.6L2.5 11v2.5H5V12h1.5v-1.5H8l.9-.9A3.5 3.5 0 0 0 10 9.5zM11 5h.01",
  eye: "M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  eyeOff: "M2 2l12 12M6.6 6.6a2 2 0 0 0 2.8 2.8M4.3 4.4C2.6 5.6 1.5 8 1.5 8S4 12.5 8 12.5c1.3 0 2.5-.4 3.5-1M7 3.6c.3 0 .7-.1 1-.1 4 0 6.5 4.5 6.5 4.5s-.5 1-1.5 2.1",
  alert: "M8 2 14.5 13.5h-13zM8 6.5v3M8 11.5h.01",
  check: "M3 8.5 6.5 12 13 4.5",
};

export function Icon({ name, className = "size-4", strokeWidth = 1.5, label }) {
  const d = PATHS[name];
  if (!d) return <span className={`inline-block shrink-0 ${className}`} aria-hidden />;
  return (
    <svg
      viewBox="0 0 16 16"
      className={`shrink-0 ${className}`}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <path d={d} />
    </svg>
  );
}

/** A spinner for buttons that are waiting on the network. */
export function Spinner({ className = "size-4" }) {
  return (
    <svg viewBox="0 0 16 16" className={`shrink-0 animate-spin ${className}`} fill="none" aria-hidden>
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
      <path d="M14 8a6 6 0 0 0-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
